module.exports = __webpack_public_path__ + "img/numeralia_cedis_3.c97a38b2.png";